import { withStyles } from '@material-ui/core/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select, Tab, Tabs, TextField, Theme } from "@material-ui/core";
import { toMap } from '../utils/utils';
import * as React from 'react';
import { ComponentClass } from 'react';
import { AppDispatch, IStore } from '../store';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';

import { RaceActions } from '../store/race/race-actions';
import DriverLocation from '../components/DriverLocation';

import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import { RaceState } from '../api/model';
import { IRaceStore } from '../store/race/race-reducer';
import { bindActionCreators } from 'redux';
import { NotificationActions } from '../store/notification/notification-actions';
import { DriverActions, IDriverStore } from '../store/driver';
import { BranchActions, BranchStore } from '../store/branch';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import StoreModel from '../store/StoreModel';
import Icon from '@material-ui/core/Icon';
// import RaceListComponent from '../components/race/RaceListComponent';
import { IConfigStore } from '../store/config';
import { IVisitStore } from 'src/store/visit/visit-reducer';
import { VisitActions } from 'src/store/visit/visit-actions';
import VisitsLocation from 'src/components/VisitsLocation';
// import VisitListComponent from 'src/components/visits/VisitListComponent';
import { RouteComponentProps } from 'react-router-dom';
// import RaceListComponent from 'src/components/race/RaceListComponent';
import { TableRacesComponent } from 'src/components/TableRacesComponent';
import { TableVisitsComponent } from 'src/components/TableVisitsComponent';

// Importaciones de Chart.js para gráficas
import { Bar, Line, Pie } from 'react-chartjs-2';
import { TablePlanningComponent } from 'src/components/TablePlanningComponent';
import { PlanningDetailsModal } from 'src/components/PlanningDetailsModal';

const styles = (theme: Theme) => ({
    panel: theme.mixins.gutters({
        paddingTop: 16,
        paddingBottom: 16,
        marginTop: theme.spacing.unit * 3,
    }),
    icon: {}
});


/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */

const tipoComprobante = [
    { value: "FAC", label: "FAC" },
    { value: "RET", label: " RET" },
    { value: "NCR", label: " NCR" },
    { value: "REC", label: " REC" },
    { value: "AUT", label: " AUT" },
    { value: "FAE", label: " FAE" },
    { value: "CV", label: "CV" },
    { value: "ADEL", label: "ADEL" },
    { value: "EXT", label: "EXT" }
];

interface DashboardProps extends RouteComponentProps<any> {

    actions: RaceActions;
    driverActions: DriverActions;
    visitActions: VisitActions;
    branchActions: BranchActions;
    data: IRaceStore;
    driver: IDriverStore;
    config: IConfigStore;
    visit: IVisitStore;
    branch: BranchStore;
    classes: any; // Agregado para compatibilidad
}

interface DashboardState {
    openDialog: boolean;
    openDialogBranch: boolean;
    openDialogDriver: boolean;
    openDialogClient: boolean;
    openDialogChangeState: boolean;
    tabValue: number;
    dataTemp: any;
    filterLoc: string;
    pageNum: number;
    pageSize: number;
    filter: string;
    pageNumVisit: number;
    pageSizeVisit: number;
    filterVisit: string;
    dateFromVisit: string;
    dateToVisit: string;
    // params to search
    dateFrom?: string;
    dateTo?: string;
    selectedType?: string;
    selectedState?: string;
    driverId?: number;
    branchId?: number;
    branchDestinyId?: number;
    generalSearch?: string;
    // Planning pagination
    pagePlanningNum: number;
    pagePlanningSize: number;
    // Planning modal
    planningModalOpen: boolean;
    selectedPlanning: any;
}

class Dashboard extends React.Component<DashboardProps, DashboardState> {



    constructor(props: DashboardProps) {
        super(props);

        this.state = {
            openDialog: false,
            openDialogBranch: false,
            openDialogDriver: false,
            openDialogClient: false,
            openDialogChangeState: false,
            tabValue: 0,
            dataTemp: {},
            filterLoc: '',
            pageNum: 0,
            pageSize: 5,
            filter: '',
            pageNumVisit: 0,
            pageSizeVisit: 5,
            filterVisit: '',
            dateFrom: '',
            dateTo: '',
            dateFromVisit: '',
            dateToVisit: '',
            selectedType: '',
            selectedState: '',
            driverId: undefined,
            generalSearch: '',
            pagePlanningNum: 0,
            pagePlanningSize: 5,
            planningModalOpen: false,
            selectedPlanning: null,
        };


        this.loadByState = this.loadByState.bind(this);
    }
    // Modificar documentos
    setDialog = (open: boolean, data?: any) => {
        this.setState({
            openDialog: open,
            dataTemp: data
        });
    }
    setDialogBranch = (open: boolean, data?: any) => {
        this.setState({
            openDialogBranch: open,
            dataTemp: data
        });
    }
    setDialogDriver = (open: boolean, data?: any) => {
        this.setState({
            openDialogDriver: open,
            dataTemp: data
        });
    }
    setDialogClient = (open: boolean, data?: any) => {
        this.setState({
            openDialogClient: open,
            dataTemp: data
        });
    }
    setDialogChangeState = (open: boolean, data?: any) => {
        this.setState({
            openDialogChangeState: open,
            dataTemp: data
        });
    }
    getFormattedDateTime = (fecha: any) => {
        const now = fecha ? new Date(fecha) : new Date();
        const year = now.getFullYear();
        const month = (now.getMonth() + 1 < 10 ? '0' : '') + (now.getMonth() + 1);
        const day = (now.getDate() < 10 ? '0' : '') + now.getDate();
        const hours = (now.getHours() < 10 ? '0' : '') + now.getHours();
        const minutes = (now.getMinutes() < 10 ? '0' : '') + now.getMinutes();
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };
    onChangeHora = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            dataTemp: {
                ...this.state.dataTemp,
                state: 'DELIVERED',
                finishedTime: e.target.value
            }
        });
    }
    handleSelectChangeComprobanteOnRow = (event: React.ChangeEvent<HTMLSelectElement>) => {
        this.setState({
            dataTemp: {
                ...this.state.dataTemp,
                tipoComprobante: event.target.value
            }
        });
    };
    setNroComprobante = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({
            dataTemp: {
                ...this.state.dataTemp,
                nroComprobante: e.target.value
            }
        });
    }
    guardarDocumento = () => {
        this.setDialog(false);
        this.props.actions.update(this.state.dataTemp, this.props.history);
    }
    guardarStatus = () => {
        this.setDialogChangeState(false);
        const finishedTime = this.state.dataTemp.finishedTime || new Date().toISOString().slice(0, 16);
        const updatedData = {
            ...this.state.dataTemp,
            state: 'DELIVERED',
            finishedTime: finishedTime
        };
        this.props.actions.updateState(
            updatedData,
            this.props.history,
            () => {
                this.busquedaPorFiltros();
            }
        );
    }
    // FIN Modificar documentos

    componentDidMount() {
        this.props.actions.fetchAllPlaninng();
        this.props.driverActions.fetchLocations();
        this.props.driverActions.fetch();
        this.props.branchActions.fetch();
        this.getRaces(0, 5, '');
        this.getVisits(0, 5, '');
    }

    loadByState(state: RaceState) {
        this.props.actions.fetchByState(state);

    }
    getRaces(pageNum?: number, pageSize?: number, search?: string, from?: string, to?: string, type?: string, driverId?: number, selectedState?: string, branchId?: number, branchDestinyId?: number, generalSearch?: string) {
        this.props.actions.fetchAllWithFilters(pageNum, pageSize, search, from, to, type, driverId, selectedState, branchId, branchDestinyId, generalSearch);
    }
    getVisits(pageNum?: number, pageSize?: number, search?: string, from?: string, to?: string) {
        this.props.visitActions.fetchAllWithFilters(pageNum, pageSize, search, from, to);
    }

    setFilter = (filter: string) => {
        this.setState({ filter }, () => {
            this.getRaces(this.state.pageNum, this.state.pageSize, this.state.filter, this.state.dateFrom, this.state.dateTo);
        });
    };

    setPageNum = (pageNum: number) => {
        this.setState({ pageNum }, () => {
            this.busquedaPorFiltros();
        });
    };

    setPageSize = (pageSize: number) => {
        this.setState({ pageSize }, () => {
            this.busquedaPorFiltros();
        });
    };

    setDateFromChange = (dateFrom: string) => {
        this.setState({ dateFrom }, () => {
            this.busquedaPorFiltros();
        });
    };

    setDateToChange = (dateTo: string) => {
        this.setState({ dateTo }, () => {
            this.busquedaPorFiltros();
        });
    };
    setDateFromChangeVisit = (dateFromVisit: string) => {
        this.setState({ dateFromVisit }, () => {
            this.getVisits(this.state.pageNumVisit, this.state.pageSizeVisit, this.state.filterVisit, this.state.dateFromVisit, this.state.dateToVisit);
        });
    };

    setDateToChangeVisit = (dateToVisit: string) => {
        this.setState({ dateToVisit }, () => {
            this.getVisits(this.state.pageNumVisit, this.state.pageSizeVisit, this.state.filterVisit, this.state.dateFromVisit, this.state.dateToVisit);
        });
    };

    setFilterVisit = (filterVisit: string) => {
        this.setState({ filterVisit }, () => {
            this.getVisits(this.state.pageNumVisit, this.state.pageSizeVisit, this.state.filterVisit, this.state.dateFromVisit, this.state.dateToVisit);
        });
    };

    setPageNumVisit = (pageNumVisit: number) => {
        this.setState({ pageNumVisit }, () => {
            this.getVisits(this.state.pageNumVisit, this.state.pageSizeVisit, this.state.filterVisit, this.state.dateFromVisit, this.state.dateToVisit);
        });
    };

    setPageSizeVisit = (pageSizeVisit: number) => {
        this.setState({ pageSizeVisit }, () => {
            this.getVisits(this.state.pageNumVisit, this.state.pageSizeVisit, this.state.filterVisit, this.state.dateFromVisit, this.state.dateToVisit);
        });
    };
    cleanFiltersRaces = () => {
        this.setState({ filter: '', dateFrom: '', dateTo: '', selectedType: undefined, driverId: undefined, selectedState: undefined,branchId:undefined,branchDestinyId:undefined,generalSearch:'' }, () => {
            this.busquedaPorFiltros();
        });
    }
    cleanFiltersVisits = () => {
        this.setState({ filterVisit: '', dateFromVisit: '', dateToVisit: '' }, () => {
            this.getVisits(this.state.pageNumVisit, this.state.pageSizeVisit, this.state.filterVisit, this.state.dateFromVisit, this.state.dateToVisit);
        });
    }

    handleTypeChange = (selectedType: string) => {
        this.setState({ selectedType }, () => {
            this.busquedaPorFiltros();
        });
    }
    handleStateChange = (selectedState: string) => {
        this.setState({ selectedState }, () => {
            this.busquedaPorFiltros();
        });
    }
    handleDriverChange = (driverId: number) => {
        this.setState({ driverId }, () => {
            this.busquedaPorFiltros();
        });
    }
    handleBranchChange = (branchId: number) => {
        this.setState({ branchId }, () => {
            this.busquedaPorFiltros();
        });
    }
    handleBranchDestinyChange = (branchDestinyId: number) => {
        this.setState({ branchDestinyId }, () => {
            this.busquedaPorFiltros();
        });
    }
    handleGeneralSearch = (search: string) => {
        this.setState({ generalSearch: search }, () => {
            if (this.state.generalSearch && this.state.generalSearch.length > 2) {
                this.busquedaPorFiltros();
            }
        });
    }
    busquedaPorFiltros = () => {
        if (this.state.generalSearch && this.state.generalSearch.length > 2) {
            this.getRaces(
                this.state.pageNum, 
                this.state.pageSize, 
                this.state.filter, 
                this.state.dateFrom, 
                this.state.dateTo, 
                this.state.selectedType, 
                this.state.driverId, 
                this.state.selectedState, 
                this.state.branchId, 
                this.state.branchDestinyId, 
                this.state.generalSearch
            );
        } else {
            this.getRaces(
                this.state.pageNum, 
                this.state.pageSize, 
                this.state.filter, 
                this.state.dateFrom, 
                this.state.dateTo, 
                this.state.selectedType, 
                this.state.driverId, 
                this.state.selectedState, 
                this.state.branchId, 
                this.state.branchDestinyId
            );
        }
    }

    // Planning handlers
    setPlanningPageNum = (pagePlanningNum: number) => {
        this.setState({ pagePlanningNum }, () => {
            this.props.actions.fetchAllPlanningPaginated(pagePlanningNum, this.state.pagePlanningSize);
        });
    };

    setPlanningPageSize = (pagePlanningSize: number) => {
        this.setState({ pagePlanningSize }, () => {
            this.props.actions.fetchAllPlanningPaginated(this.state.pagePlanningNum, pagePlanningSize);
        });
    };

    handleViewPlanningDetails = (planning: any) => {
        this.setState({
            selectedPlanning: planning,
            planningModalOpen: true
        });
    };

    handleDeletePlanning = (planningId: string) => {
        const id = parseInt(planningId, 10);
        this.props.actions.deletePlanning(id, this.state.pagePlanningNum, this.state.pagePlanningSize);
    };

    handleClosePlanningModal = () => {
        this.setState({
            planningModalOpen: false,
            selectedPlanning: null
        });
    };
    renderPlanningList() {
        if (StoreModel.isLoading(this.props.data.allPlanning)) {
            return (
                <LinearProgress />
            )
        }
        if (StoreModel.isError(this.props.data.allPlanning)) {
            return (    
                <Typography color="error">
                    Error: {this.props.data.resume.error}
                </Typography>
            )
        }
        
        const planningData = this.props.data.allPlanning.data || [];
        
        return (
            <Grid>
                <TablePlanningComponent
                    data={planningData}
                    totalItems={planningData.length}
                    pageNum={this.state.pagePlanningNum}
                    pageSize={this.state.pagePlanningSize}
                    onPageNumChange={this.setPlanningPageNum}
                    onPageSizeChange={this.setPlanningPageSize}
                    onViewDetails={this.handleViewPlanningDetails}
                    onDelete={this.handleDeletePlanning}
                />
            </Grid>
        )
    }

    renderRaceList() {
        if (StoreModel.isLoading(this.props.data.all)) {
            return (
                <LinearProgress />
            )
        }
        if (StoreModel.isError(this.props.data.all)) {
            return (
                <Typography color="error">
                    Error: {this.props.data.resume.error}
                </Typography>
            )
        }

        const raceData: any = this.props.data.all.data || [];
        const totalItems = Array.isArray(raceData) ? raceData.length : (raceData.totalElements || 0);
        const races = Array.isArray(raceData) ? raceData : (raceData.content || []);

        return (
            <Grid>
                <TableRacesComponent
                    data={races}
                    dataDrivers={this.props.driver.data.data || []}
                    dataBranches={this.props.branch.data.data || []}
                    dataBranchesDestiny={this.props.branch.data.data || []}
                    totalItems={totalItems}
                    pageNum={this.state.pageNum}
                    pageSize={this.state.pageSize}
                    filter={this.state.filter}
                    onFilterChange={this.setFilter}
                    onPageNumChange={this.setPageNum}
                    onPageSizeChange={this.setPageSize}
                    onDateFromChange={this.setDateFromChange}
                    onDateToChange={this.setDateToChange}
                    onHandleTypeChange={this.handleTypeChange}
                    onHandleDriverChange={this.handleDriverChange}
                    onHandleStateChange={this.handleStateChange}
                    onHandleBranchChange={this.handleBranchChange}
                    onHandleBranchDestinyChange={this.handleBranchDestinyChange}
                    handleClearFilters={this.cleanFiltersRaces}
                    handleGeneralSearch={this.handleGeneralSearch}
                    dateFrom={this.state.dateFrom ? this.state.dateFrom : ''}
                    dateTo={this.state.dateTo ? this.state.dateTo : ''}
                    setDialog={this.setDialog}
                    setDialogBranch={this.setDialogBranch}
                    setDialogDriver={this.setDialogDriver}
                    setDialogClient={this.setDialogClient}
                    setDialogChangeState={this.setDialogChangeState}
                    selectedType={this.state.selectedType ? this.state.selectedType : ''}
                    selectedState={this.state.selectedState ? this.state.selectedState : ''}
                    driverId={this.state.driverId ? this.state.driverId : 0}
                    branchId={this.state.branchId ? this.state.branchId : 0}
                    branchDestinyId={this.state.branchDestinyId ? this.state.branchDestinyId : 0}
                    generalSearch={this.state.generalSearch ? this.state.generalSearch : ''}
                    racetoAdd={false}
                    filtrosOn={true}
                />
                <Dialog open={this.state.openDialog} onClose={() => this.setDialog(false)}>
                    <DialogTitle>{"Documentos del Reparto"}</DialogTitle>
                    <DialogContent>
                        <Typography gutterBottom>
                            Tipo de documento
                        </Typography>
                        <Select value={this.state.dataTemp && this.state.dataTemp.tipoComprobante ? this.state.dataTemp.tipoComprobante : ''} onChange={(event) => this.handleSelectChangeComprobanteOnRow(event)}>
                            {tipoComprobante.map((option, index) => (
                                <MenuItem key={index} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>

                        <TextField
                            label="Nro documento (opcional)"
                            type="number"
                            onChange={(e) => this.setNroComprobante(e)}
                            value={this.state.dataTemp && this.state.dataTemp.nroComprobante ? this.state.dataTemp.nroComprobante : ''}
                            style={{
                                width: '90%'
                            }}
                            margin="normal"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.guardarDocumento()} color="primary">
                            Guardar
                        </Button>
                        <Button onClick={() => this.setDialog(false)} color="secondary">
                            Cerrar
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog open={this.state.openDialogBranch} onClose={() => this.setDialogBranch(false)}>
                    <DialogTitle>{"Sucursal de Conductor"}</DialogTitle>
                    <DialogContent>
                        <Typography gutterBottom>
                            {this.state.dataTemp ? 'Nombre de sucursal: ' + this.state.dataTemp.name : ''}
                        </Typography>
                        <Typography gutterBottom>
                            {
                                this.state.dataTemp
                                    && this.state.dataTemp.company ? 'Nombre de compañía: ' + this.state.dataTemp.company.name : ''}
                        </Typography>
                        <Typography gutterBottom>
                            {
                                this.state.dataTemp
                                    && this.state.dataTemp.location ? 'Calle principal: ' + this.state.dataTemp.location.street1 : ''}
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setDialogBranch(false)} color="secondary">
                            Cerrar
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.openDialogDriver} onClose={() => this.setDialogDriver(false)}>
                    <DialogTitle>{"Conductor"}</DialogTitle>
                    <DialogContent>
                        <Typography gutterBottom>
                            {this.state.dataTemp && this.state.dataTemp.user ? 'Nombre de conductor: ' + this.state.dataTemp.user.name : ''}
                        </Typography>
                        <Typography gutterBottom>
                            {
                                this.state.dataTemp
                                    && this.state.dataTemp.document ? 'Nro de documento: ' + this.state.dataTemp.document : ''}
                        </Typography>
                        <Typography gutterBottom>
                            {
                                this.state.dataTemp
                                    && this.state.dataTemp.registryNumber ? 'Nro de registro: ' + this.state.dataTemp.registryNumber : ''}
                        </Typography>
                        <Typography gutterBottom>
                            {
                                this.state.dataTemp
                                    && this.state.dataTemp.region ? 'Región: ' + this.state.dataTemp.region : ''}
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setDialogDriver(false)} color="secondary">
                            Cerrar
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.openDialogClient} onClose={() => this.setDialogClient(false)}>
                    <DialogTitle>{"Cliente"}</DialogTitle>
                    <DialogContent>
                        <Typography gutterBottom>
                            {this.state.dataTemp && this.state.dataTemp && this.state.dataTemp.user ? 'Nombre de cliente: ' + this.state.dataTemp.user.name : ''}
                        </Typography>
                        <Typography gutterBottom>
                            {
                                this.state.dataTemp
                                    && this.state.dataTemp ? 'Nro de documento: ' + this.state.dataTemp.document : ''}
                        </Typography>
                        <Typography gutterBottom>
                            {
                                this.state.dataTemp
                                    && this.state.dataTemp ? 'Teléfono: ' + this.state.dataTemp.phone : ''}
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.setDialogClient(false)} color="secondary">
                            Cerrar
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={this.state.openDialogChangeState} onClose={() => this.setDialogChangeState(false)}>
                    <DialogTitle>{"Cambiar Estado"}</DialogTitle>
                    <DialogContent>
                        <Typography gutterBottom>
                            Fecha y hora de Finalización
                        </Typography>
                        <TextField
                            label="Fecha y Hora"
                            type="datetime-local"
                            onChange={(e) => this.onChangeHora(e)}
                            value={this.state.dataTemp && this.state.dataTemp.finishedTime ? this.state.dataTemp.finishedTime : new Date().toISOString().slice(0, 16)}
                            style={{ width: '90%' }}
                            margin="normal"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.guardarStatus()} color="primary">
                            Guardar
                        </Button>
                        <Button onClick={() => this.setDialogChangeState(false)} color="secondary">
                            Cerrar
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        )
    }

    renderStatistics() {
        // Datos de ejemplo para gráficas
        const barData = {
            labels: ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'],
            datasets: [{
                label: 'Repartos por día',
                data: [12, 18, 15, 22, 28, 20, 16],
                backgroundColor: 'rgba(54, 162, 235, 0.6)',
                borderColor: 'rgba(54, 162, 235, 1)',
                borderWidth: 1
            }]
        };

        const lineData = {
            labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun'],
            datasets: [{
                label: 'Tiempo promedio (min)',
                data: [45, 42, 48, 38, 35, 40],
                borderColor: 'rgba(255, 99, 132, 1)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                tension: 0.4
            }]
        };

        const pieData = {
            labels: ['Repartos', 'Visitas', 'Entrea de Paquetes'],
            datasets: [{
                data: [40, 35, 25],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.6)',
                    'rgba(54, 162, 235, 0.6)',
                    'rgba(255, 205, 86, 0.6)'
                ]
            }]
        };

        const options = {
            responsive: true,
            maintainAspectRatio: false
        };

        return (
            <Grid container spacing={24}>
                {/* Gráfica de barras */}
                <Grid item xs={12} md={6}>
                    <Paper className={this.props.classes.panel} elevation={5}>
                        <Typography variant="headline" component="h3" style={{ marginBottom: 16 }}>
                            Repartos por Día
                        </Typography>
                        <div style={{ height: '300px' }}>
                            <Bar data={barData} options={options} />
                        </div>
                    </Paper>
                </Grid>

                {/* Gráfica de líneas */}
                <Grid item xs={12} md={6}>
                    <Paper className={this.props.classes.panel} elevation={5}>
                        <Typography variant="headline" component="h3" style={{ marginBottom: 16 }}>
                            Tiempo Promedio
                        </Typography>
                        <div style={{ height: '300px' }}>
                            <Line data={lineData} options={options} />
                        </div>
                    </Paper>
                </Grid>

                {/* Gráfica de pastel */}
                <Grid item xs={12} md={6}>
                    <Paper className={this.props.classes.panel} elevation={5}>
                        <Typography variant="headline" component="h3" style={{ marginBottom: 16 }}>
                            Tipos de Servicio
                        </Typography>
                        <div style={{ height: '300px', display: 'flex', justifyContent: 'center' }}>
                            <Pie data={pieData} options={options} />
                        </div>
                    </Paper>
                </Grid>

                {/* Estadísticas en tarjetas */}
                <Grid item xs={12} md={6}>
                    <Grid container spacing={16}>
                        <Grid item xs={12} sm={6}>
                            <Paper className={this.props.classes.panel} elevation={5} style={{ textAlign: 'center', padding: 24 }}>
                                <Typography variant="headline" component="h3" color="primary">
                                    156
                                </Typography>
                                <Typography variant="subheading">
                                    Repartos Totales
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Esta semana
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Paper className={this.props.classes.panel} elevation={5} style={{ textAlign: 'center', padding: 24 }}>
                                <Typography variant="headline" component="h3" style={{ color: '#4CAF50' }}>
                                    85%
                                </Typography>
                                <Typography variant="subheading">
                                    Tasa de Éxito
                                </Typography>
                                <Typography variant="body2" color="textSecondary">
                                    Repartos entregados
                                </Typography>
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    }

    renderVisitList() {
        if (StoreModel.isLoading(this.props.visit.all)) {
            return (
                <LinearProgress />
            )
        }
        if (StoreModel.isError(this.props.visit.all)) {
            return (
                <Typography color="error">
                    Error: {this.props.visit.resume.error}
                </Typography>
            )
        }

        const visitData: any = this.props.visit.all.data || [];
        const totalItemsVisit = Array.isArray(visitData) ? visitData.length : (visitData.totalElements || 0);
        const visits = Array.isArray(visitData) ? visitData : (visitData.content || []);

        // return <VisitListComponent data={this.props.visit.all.data} />
        return <TableVisitsComponent
            data={visits}
            totalItems={totalItemsVisit}
            pageNum={this.state.pageNumVisit}
            pageSize={this.state.pageSizeVisit}
            filter={this.state.filterVisit}
            onFilterChange={this.setFilterVisit}
            onPageNumChange={this.setPageNumVisit}
            onPageSizeChange={this.setPageSizeVisit}
            onDateFromChangeVisit={this.setDateFromChangeVisit}
            onDateToChangeVisit={this.setDateToChangeVisit}
            handleClearFilters={this.cleanFiltersVisits}
            dateFromVisit={this.state.dateFromVisit}
            dateToVisit={this.state.dateToVisit}
        />
    }
    handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        this.setState({ tabValue: newValue });
    };

    render() {

        // Filtrar ubicaciones válidas para DriverLocation
        const validDriverLocations = Array.isArray(this.props.driver.locations.data)
            ? this.props.driver.locations.data.filter(loc => typeof loc.lat === 'number' && typeof loc.lng === 'number')
            : [];

        // Filtrar ubicaciones válidas para VisitsLocation
        const validVisitLocations = Array.isArray(this.props.visit.all.data)
            ? this.props.visit.all.data.filter(loc => typeof loc.lat === 'number' && typeof loc.lng === 'number')
            : [];

        return (
            <>
            <Grid container spacing={8} alignItems="center" style={{ width: '100%' }} >
                <Grid item sm={10} md={10} lg={10}>
                    <Tabs value={this.state.tabValue} onChange={this.handleTabChange}>
                        <Tab label="Planificaciones" />
                        <Tab label="Repartos" />
                        <Tab label="Visitas" />
                        <Tab label="Estadísticas" />
                    </Tabs>
                    {this.state.tabValue === 0 && (
                        <>
                            <Paper className={this.props.classes.panel} elevation={5} >
                                <Typography variant="headline" component="h3">
                                    Planificaciones
                                    <Icon className={this.props.classes.icon} color="primary"
                                        onClick={this.props.actions.fetchAllPlaninng}>
                                        refresh
                                    </Icon>
                                </Typography>

                                {this.renderPlanningList()}
                            </Paper>
                        </>
                    )}
                    {
                        this.state.tabValue === 1 && (
                            <>
                                <Paper className={this.props.classes.panel} elevation={5} >
                                    <Typography variant="headline" component="h3">
                                        Repartos
                                    </Typography>

                                    {this.renderRaceList()}
                                </Paper>

                                <Grid item sm={12} md={12} lg={12}>
                                    <Paper className={this.props.classes.panel} elevation={5}>
                                        <BlockUi tag="div" blocking={StoreModel.isLoading(this.props.driver.locations)}>
                                            <Typography variant="headline" component="h3">Ubicación de motistas
                                                <Icon className={this.props.classes.icon} color="primary"
                                                    onClick={this.props.driverActions.fetchLocations}>
                                                    refresh
                                                </Icon>
                                            </Typography>
                                            <DriverLocation data={validDriverLocations} config={this.props.config.data} />
                                        </BlockUi>
                                    </Paper>
                                </Grid>
                            </>
                        )
                    }
                    {
                        this.state.tabValue === 2 && (
                            <>
                                <Paper className={this.props.classes.panel} elevation={5}>

                                    <Typography variant="headline" component="h3">
                                        Visitas
                                        {/* <Icon className={this.props.classes.icon} color="primary"
                                            onClick={this.props.actions.fetchAll}>refresh
                                        </Icon> */}
                                    </Typography>


                                    {this.renderVisitList()}

                                </Paper>

                                <Paper className={this.props.classes.panel} elevation={5}>

                                    <Grid item sm={12} md={12} lg={12}>
                                        <Paper className={this.props.classes.panel} elevation={5}>
                                            <BlockUi tag="div" blocking={StoreModel.isLoading(this.props.visit.all)}>
                                                <Typography variant="headline" component="h3">Ubicación de visitas
                                                    <Icon className={this.props.classes.icon} color="primary"
                                                        onClick={this.props.visitActions.fetchAll}>
                                                        refresh
                                                    </Icon>
                                                </Typography>
                                                <VisitsLocation
                                                    data={validVisitLocations}
                                                    config={this.props.config.data} />
                                            </BlockUi>
                                        </Paper>
                                    </Grid>
                                </Paper>
                            </>
                        )
                    }
                    {
                        this.state.tabValue === 3 && (
                            <>
                                <Paper className={this.props.classes.panel} elevation={5}>
                                    <Typography variant="headline" component="h3">
                                        Estadísticas y Métricas
                                    </Typography>
                                    {this.renderStatistics()}
                                </Paper>
                            </>
                        )
                    }
                </Grid>
            </Grid>
            <PlanningDetailsModal
                open={this.state.planningModalOpen}
                planning={this.state.selectedPlanning}
                onClose={this.handleClosePlanningModal}
            />
            </>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: DashboardProps): DashboardProps => ({
    ...ownProps,
    data: state.race,
    driver: state.driver,
    visit: state.visit,
    config: state.config,
    branch: state.branch
});


const connected = connect(mapStateToProps, (dispatch: AppDispatch) => {
    return {
        actions: bindActionCreators(toMap(RaceActions), dispatch),
        driverActions: bindActionCreators(toMap(DriverActions), dispatch),
        visitActions: bindActionCreators(toMap(VisitActions), dispatch),
        branchActions: bindActionCreators(toMap(BranchActions), dispatch),
        notification: bindActionCreators(toMap(NotificationActions), dispatch)
    }
})(Dashboard);

const styled = withStyles(styles as any)(connected);

export default styled as ComponentClass<Partial<DashboardProps>>;



// WEBPACK FOOTER //
// ./src/pages/DashboardPage.tsx